function clamp(value, minimum, maximum) {
  return Math.max(minimum, Math.min(value, maximum));
}

function px(value) {
  return `${Math.max(0, Math.round(value))}px`;
}

export function getOnboardingCalloutLayout(viewportWidth, viewportHeight, targetRect) {
  const width = Math.max(1, Number(viewportWidth) || 1024);
  const height = Math.max(1, Number(viewportHeight) || 768);
  const mobile = width <= 640;
  const edge = mobile ? 8 : 16;
  const gap = mobile ? 10 : 24;
  const cardWidth = Math.max(1, Math.min(560, width - edge * 2));
  const viewportMaxHeight = Math.max(1, height - edge * 2);
  const baseStyle = mobile
    ? { left: px(edge), right: px(edge), width: 'auto' }
    : { width: px(cardWidth) };

  if (!targetRect) {
    return mobile
      ? {
        style: {
          ...baseStyle,
          top: 'auto',
          bottom: px(edge),
          maxHeight: px(viewportMaxHeight),
        },
        arrowClass: 'is-hidden',
      }
      : {
        style: {
          ...baseStyle,
          top: '50%',
          left: '50%',
          maxHeight: px(viewportMaxHeight),
          transform: 'translate(-50%, -50%)',
        },
        arrowClass: 'is-hidden',
      };
  }

  const targetTop = clamp(Number(targetRect.top) || 0, 0, height);
  const targetBottom = clamp(Number(targetRect.bottom) || targetTop, targetTop, height);
  const spaceAbove = Math.max(0, targetTop - gap - edge);
  const spaceBelow = Math.max(0, height - targetBottom - gap - edge);
  const minimumUsefulHeight = mobile ? 150 : 240;
  const preferredHeight = mobile
    ? Math.max(250, Math.min(380, Math.round(height * 0.48)))
    : Math.min(560, viewportMaxHeight);

  // If neither side leaves enough room for usable controls, overlay the page
  // and dedicate the viewport to a scrollable card instead of clipping it.
  if (Math.max(spaceAbove, spaceBelow) < minimumUsefulHeight) {
    return {
      style: {
        ...baseStyle,
        top: px(edge),
        bottom: px(edge),
        ...(mobile ? {} : { left: px(clamp(
          (Number(targetRect.left) || 0) + (Number(targetRect.width) || 0) / 2 - cardWidth / 2,
          edge,
          width - cardWidth - edge,
        )) }),
        maxHeight: px(viewportMaxHeight),
        transform: 'none',
      },
      arrowClass: 'is-hidden',
    };
  }

  const placeBelow = spaceBelow >= spaceAbove;
  const availableHeight = placeBelow ? spaceBelow : spaceAbove;
  const maxHeight = Math.min(preferredHeight, availableHeight);
  const targetCenter = (Number(targetRect.left) || 0) + (Number(targetRect.width) || 0) / 2;
  const left = mobile ? null : clamp(targetCenter - cardWidth / 2, edge, width - cardWidth - edge);
  const arrowLeft = mobile ? null : clamp(targetCenter - left - 9, 24, cardWidth - 36);

  return {
    style: {
      ...baseStyle,
      top: placeBelow ? px(targetBottom + gap) : 'auto',
      bottom: placeBelow ? 'auto' : px(height - targetTop + gap),
      ...(mobile ? {} : {
        left: px(left),
        '--tour-arrow-left': px(arrowLeft),
      }),
      maxHeight: px(maxHeight),
      transform: 'none',
    },
    arrowClass: mobile ? 'is-hidden' : (placeBelow ? 'is-above' : 'is-below'),
  };
}
